module.exports = __webpack_public_path__ + "static/media/img_mobile_overseas_01.b8d93bf7.png";